// DIGITAL OVERRIDE — force product pages to be purchasable even if theme tries to disable variants/buttons
(function () {
  function enableAll(ctx) {
    ctx = ctx || document;

    // Re-enable any disabled purchase buttons
    ctx.querySelectorAll('button[disabled], input[disabled], select[disabled], textarea[disabled]').forEach(function (el) {
      el.disabled = false;
      el.removeAttribute('disabled');
      el.setAttribute('aria-disabled', 'false');
      el.classList.remove('disabled', 'is-disabled');
    });

    // Remove common "sold out" / disabled classes used by themes
    ctx.querySelectorAll('.disabled, .is-disabled, .soldout, .sold-out, .is-sold-out').forEach(function (el) {
      el.classList.remove('disabled', 'is-disabled', 'soldout', 'sold-out', 'is-sold-out');
    });

    // Force ATC label if theme swapped it
    ctx.querySelectorAll('button[name="add"] span, button.product-form__submit span').forEach(function (span) {
      if (span && /sold\s*out/i.test(span.textContent || '')) {
        span.textContent = 'Add to cart';
      }
    });
  }

  // Run now + after variant changes
  document.addEventListener('DOMContentLoaded', function () {
    enableAll(document);

    // Watch DOM for themes that re-disable after you enable
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'attributes' || mutations[i].addedNodes.length) {
          enableAll(document);
          break;
        }
      }
    });

    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled']
    });
  });
})();
